module.exports = __webpack_public_path__ + "media/images/landing/persons/josef-novak-68ec7dcab306f16bd739f553dd54bd87.png";